import React from "react";
import MetricCard from "../../../component/cards/metricCard";
import { Text } from "rizzui";
import cn from "../../../lib/utils/class-name";
import { CampaignAnalytics } from "../../../lib/types";

const MetricText = ({ value }) => (
  <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
    {value}
  </Text>
);

export default function StatCards({
  className,
  data,
}: {
  className?: string;
  data: CampaignAnalytics;
}) {
  const DashboardStatData = [
    {
      id: "1",
      title: "Leads",
      metric: <MetricText value={data?.leads_in_campaign} />,
      increased: false,
      percentage: "-23.45",
    },
    {
      id: "2",
      title: "Total calls made",
      metric: <MetricText value={data?.totalCallsMade} />,
      increased: true,
      percentage: "+23.45",
    },
    {
      id: "3",
      title: "Total call mins",
      metric: (
        <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
          {typeof data?.averageCallMinutes === "number" &&
          typeof data?.totalCallsMade === "number" &&
          data.totalCallsMade !== 0
            ? Math.ceil(data.averageCallMinutes / data.totalCallsMade)
            : "0"}{" "}
          <span className="font-[400] text-[14px] leading-[18.48px]">mins</span>
        </Text>
      ),
      increased: true,
      percentage: "+50.45",
    },
    {
      id: "4",
      title: "Avg call mins",
      metric: (
        <Text className="font-switzer font-[500] text-[24px] leading-[31.68px] text-primary-dark mt-[16px]">
          {typeof data?.averageCallMinutes === "number"
            ? Math.ceil(data.averageCallMinutes / 60)
            : "--"}{" "}
          <span className="font-[400] text-[14px] leading-[18.48px]">mins</span>
        </Text>
      ),
      increased: false,
      percentage: "-23.45",
    },
  ];
  return (
    <div className={cn("grid gap-[22px] 3xl:gap-8 4xl:gap-9", className)}>
      {DashboardStatData.map((stat) => (
        <MetricCard
          key={stat.title + stat.id}
          title={stat.title}
          titleClassName="font-switzer font-[400] text-[14px] leading-[18.48px] text-[#758599]"
          metric={stat.metric}
          metricClassName="text-white dark:text-white"
          className="@container [&>div]:items-center rounded-[8px] border-[.5px] border-muted p-[16px] dark:bg-[#2A2C30]"
        />
      ))}
    </div>
  );
}
